<template>
  <v-text-field
    :rules="yearRules"
    v-model="data[modifyIndex].dob"
    label="Year of Birth"
    prepend-icon="event"></v-text-field>
</template>

<script>
import { mapFields } from "vuex-map-fields";
export default {
  props: {
    data: Array,
    modifyIndex: Number
  },
  data: () => ({
    date: null,
    menu: false,
    yearRules: [
      v => /^\d{4}$/.test(v) || /^\d{0}$/.test(v) || 'Please enter a valid year of birth'
    ],
  }),
};
</script>
